module.exports = __webpack_public_path__ + "static/media/mes_pv.8aae839b.svg";